<template>
    <div>
        <utility-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter"
                        :paginationData="filterSet.page" :parentCategory="parentCategory" :childCategory="childCategory" ></utility-filter-link>
        <utility-list-link :listLayout="listLayout" :utilityData="List" :paginationData="filterSet.page"></utility-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page" :listLength="List.length"
                        :finishGetList="finishGetList" v-if="filterSet.page.total"></pagination-link>
    </div>
</template>

<script>

import utilityUtil from '@/components/utility/utilityUtil';
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import UtilityListLink from "@/components/utility/UtilityListLink";
import UtilityFilterLink from "@/components/utility/UtilityFilterLink";
import PaginationLink from "@/components/utility/PaginationLink";
import dateMixins from "@/mixins/dateMixins";

const {filterConfig} = utilityUtil;

export default {
    name : "UtilityListComponent",
    mixins : [utilityUtil, alertMixins, filterMixins, listMixins],
    components : {
        UtilityListLink,
        UtilityFilterLink,
        PaginationLink
    },
    inject : [],
    provide(){
        return{
            setPage: this.setPage,
            setFilter: this.setFilter,
            setSort: this.setSort,
        }
    } ,
    props : {
        utilityType: '',
        memberKey:{default:0},
    },
    data(){
        return {
            listLayout: '',
            filterLayout: '',
            emptyLayout: '',
            paginationLayout: '',
            getFunc: '',
            listApiParamSet: {},

            deleteFunc: '',
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            keyName: '',
            DeleteClass: null,
            selectArr: [],
            parentCategory : [],
            childCategory : {},
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initConfig();
        this.setFilterConfig(filterConfig);
        this.setParserType('url', this.$route.fullPath);
    },
    mounted(){
         this.getList(true);
         EventBus.$on('getUtilityList', this.getList)
         this.getCategory();
         this.getChildCategory();
    },
    beforeDestroy(){

    },
    destroyed(){

    },
    computed:{},
    methods: {
        initConfig() {
            let config = this.returnUtilityConfig(this.utilityType);
            this.listLayout = config.listLayout;
            this.filterLayout = config.filterLayout;
            this.emptyLayout = config.emptyLayout;
            this.paginationLayout = config.paginationLayout;
            this.getFunc = config.getFunc;
            this.listApiParamSet = config.listApiParamSet;
            this.deleteFunc = config.deleteFunc
            this.deleteApiParamsSet = config.deleteApiParamsSet
            this.deleteSuccessType = config.deleteSuccessType
            this.deleteFailTypes = config.deleteFailTypes
            this.deleteKeyName = config.deleteKeyName
            if (config.pageRow && config.pageRow != this.filterSet.page.size) {
                this.pageRow = config.pageRow;
                this.filterSet.page.size = config.pageRow;
                this.pageClass.setterPage('size', this.pageRow);
            }
            let params = util.isEmpty(this.listApiParamSet) ? {} : JSON.parse(JSON.stringify(this.listApiParamSet));
            if (!util.isEmpty(this.memberKey) && this.memberKey !== 0) {
                params.no = this.memberKey;
            }
            let listOptions = {
                url: this.$api.$utility[this.getFunc],
                defaultParams: params,
            }
            this.sortOptions = config.sortOptions
            this.setSortOptions(this.sortOptions)
            this.initList('api', listOptions);
        },
        getCategory(){
            const params = {
                parent : [0],
            }
            this.$api.$utility.getUtilityCategory(params).then((res)=> {
                if(res.Data.Result.Info.type){
                    this.parentCategory = res.Data.Result.List;
                }
            })
        },
        getChildCategory(){
            let params = {
                parent : [],
                cf : 1,
                child : 1,
                uc_idx : []
            }
            this.$api.$utility.getUtilityCategory(params).then((res)=> {
                const category = {};
                const childCategoryItems = res.Data.Result.List;
                util.Array.each(childCategoryItems, (item, index, arr)=> {
                    if(category[item['uc_parent_id']]==undefined){
                        category[item['uc_parent_id']] = []
                    }
                    category[item['uc_parent_id']].push({
                        'uc_idx' : item['uc_idx'],
                        'name' : item['uc_name'],
                    })
                })

                this.childCategory = category;
            })
        }
    },
    watch:{},



}

</script>
